import { getBrowserInitialLocale, type LocaleCode } from '@client-app/i18n';

export interface WaitingPageContent {
    title: string;
    message: string;
}

export type WaitingPageContentKind = 'paymentReturn' | 'authorization' | 'desktopOAuth';

const WAITING_PAGE_CONTENT_BY_LOCALE: Record<LocaleCode, Record<WaitingPageContentKind, WaitingPageContent>> = {
    en: {
        paymentReturn: {
            title: 'Finalizing your payment...',
            message: 'Updating your plan and billing details. This usually takes a few seconds.',
        },
        authorization: {
            title: 'Connecting your app...',
            message: 'Opening the page to approve access. This usually takes a few seconds.',
        },
        desktopOAuth: {
            title: 'Signing in to Bustly...',
            message: 'Finishing the secure handoff to Bustly Desktop. This usually takes a few seconds.',
        },
    },
    'zh-CN': {
        paymentReturn: {
            title: '正在确认付款...',
            message: '正在更新套餐和账单信息，通常几秒内完成。',
        },
        authorization: {
            title: '正在连接应用...',
            message: '正在打开授权页面，通常几秒内完成。',
        },
        desktopOAuth: {
            title: '正在登录 Bustly...',
            message: '正在完成到 Bustly 客户端的安全交接，通常几秒内完成。',
        },
    },
};

export const PAYMENT_RETURN_WAITING_PAGE_ERROR_MESSAGE_BY_LOCALE: Record<LocaleCode, string> = {
    en: 'Payment is still processing',
    'zh-CN': '付款仍在处理中',
};

export const getWaitingPageContent = (
    kind: WaitingPageContentKind,
    locale: LocaleCode = 'en',
): WaitingPageContent => WAITING_PAGE_CONTENT_BY_LOCALE[locale]?.[kind] ?? WAITING_PAGE_CONTENT_BY_LOCALE.en[kind];

export const getBrowserWaitingPageContent = (kind: WaitingPageContentKind): WaitingPageContent => (
    getWaitingPageContent(kind, getBrowserInitialLocale())
);

export const PAYMENT_RETURN_WAITING_PAGE_CONTENT: WaitingPageContent = getWaitingPageContent('paymentReturn');

export const PAYMENT_RETURN_WAITING_PAGE_ERROR_MESSAGE = PAYMENT_RETURN_WAITING_PAGE_ERROR_MESSAGE_BY_LOCALE.en;

export const AUTHORIZATION_WAITING_PAGE_CONTENT: WaitingPageContent = getWaitingPageContent('authorization');

export const DESKTOP_OAUTH_RETURN_WAITING_PAGE_CONTENT: WaitingPageContent = getWaitingPageContent('desktopOAuth');

export const getPaymentReturnWaitingPageErrorMessage = (
    locale: LocaleCode = 'en',
) => {
    return PAYMENT_RETURN_WAITING_PAGE_ERROR_MESSAGE_BY_LOCALE[locale] ?? PAYMENT_RETURN_WAITING_PAGE_ERROR_MESSAGE_BY_LOCALE.en;
};
